import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledInput,
  type StyledInputProps,
} from '~/components/elements/StyledInput'
import { useLogEvent } from '~/hooks/useLogEvent'

import { searchWordAtom } from '../atoms'

export const SearchWordInput = () => {
  const { t } = useTranslation()
  const [searchWord, setSearchWord] = useAtom(searchWordAtom)
  const [searchWordInput, setSearchWordInput] = React.useState(searchWord)

  const handleChange = React.useCallback<EH<StyledInputProps, 'onChange'>>(
    (event) => {
      setSearchWordInput(event.value)
    },
    [setSearchWordInput],
  )

  const handleKeyDown = React.useCallback<EH<StyledInputProps, 'onKeyDown'>>(
    (event) => {
      if (
        event.key === 'Enter' &&
        // workaround for Chrome and Safari
        event.keyCode !== 229
      ) {
        event.currentTarget.blur()
      }
    },
    [],
  )

  const logEvent = useLogEvent()
  const handleBlur = React.useCallback<EH<StyledInputProps, 'onBlur'>>(() => {
    if (searchWord !== searchWordInput) {
      logEvent('Search saved table and graph')
      setSearchWord(searchWordInput)
    }
  }, [logEvent, searchWord, searchWordInput, setSearchWord])

  return (
    <StyledInput
      autoFocus={true}
      placeholder={t(
        'search_filter_by_analysis_function_name_questionnaire_name_etc',
      )}
      value={searchWordInput}
      width="100%"
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  )
}
